import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import {
  AccessControlConfigDto,
  SetAccessControlCredentialsDto,
} from '../../../models/access-control/dto/access-control-config.dto';
import { GET_ACCESS_CONTROL_CONFIGS_QUERY_KEY } from './useGetAccessControlConfigs';

// Elevated (platform) admins only — the API 403s everyone else. Invalidates
// the configs list so the row's `hasCredentials` badge refreshes.
export const useSetAccessControlCredentials = (
  organizationId: string,
  onSuccess?: (config: AccessControlConfigDto) => void,
) => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['setAccessControlCredentials', organizationId],
    mutationFn: (body: SetAccessControlCredentialsDto) =>
      apiClient.fetchApi<AccessControlConfigDto, SetAccessControlCredentialsDto>({
        method: 'PUT',
        endpoint: `access-control/admin/config/${organizationId}/credentials`,
        body,
      }),
    onSuccess: (data) => {
      queryClient.invalidateQueries(GET_ACCESS_CONTROL_CONFIGS_QUERY_KEY(organizationId));
      onSuccess?.(data);
    },
  });
};
